var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"homecontainer"},[_c('el-header',{staticClass:"courseheader"},[_vm._v("数据结构")]),_c('el-main',{staticClass:"elmain"},[_c('div',[_c('div',{staticClass:"markdown-body"},[_c('markdown-datastructure')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }